import classNames from 'classnames';
import React from 'react';

import {useConsumerSubscriptionPlan} from '@udemy/subscription-graphql';

import {withAboveTheFoldProvider} from 'src/components/above-the-fold/with-above-the-fold-provider.react-component';

import {usePersonalPlanSubscriptionPricingReady} from '../../hooks/usePersonalPlanSubscriptionPricingReady';
import {PersonalPlanLandingPageProps} from '../../personal-plan-landing-page-body.react-component';
import {usePersonalPlanCampaignNotice} from '../../personal-plan-subscription-checkout-entry-context';
import {PersonalPlanHeroSkeleton} from '../personal-plan-hero/personal-plan-hero-skeleton.react-component';
import styles from './personal-plan-banner.module.less';
import {PersonalPlanBanner} from './personal-plan-banner.react-component';

const WithAboveTheFoldPersonalPlanBanner = withAboveTheFoldProvider(PersonalPlanBanner);

export const PersonalPlanBannerWrapper = ({isPPLPRevamp}: PersonalPlanLandingPageProps) => {
    const notice = usePersonalPlanCampaignNotice();
    const plan = useConsumerSubscriptionPlan();
    const isSubscriptionPricingReady = usePersonalPlanSubscriptionPricingReady();
    if (!notice || notice.isLoading || !isSubscriptionPricingReady) {
        return (
            <div className={classNames('ud-container', styles['marketing-hero-banner'])}>
                <PersonalPlanHeroSkeleton />
            </div>
        );
    }
    const noticeUnavailable = !notice.notices.length;
    const subscriptionPlanUnavailable = !plan;
    if (noticeUnavailable || subscriptionPlanUnavailable) {
        return <WithAboveTheFoldPersonalPlanBanner plan={plan} isPPLPRevamp={isPPLPRevamp} />;
    }
    return (
        <WithAboveTheFoldPersonalPlanBanner
            plan={plan}
            notice={notice.notices[0]}
            isPPLPRevamp={isPPLPRevamp}
        />
    );
};
